import { render, staticRenderFns } from "./ShippingPhotos.vue?vue&type=template&id=78cdcef9"
import script from "./ShippingPhotos.vue?vue&type=script&lang=js"
export * from "./ShippingPhotos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports